<div class="switch-box" [ngClass]="{ 'switch-box-checked': value }">
  <nz-switch
    class="switch green-corner-switch"
    [nzDisabled]="(isBoundaryBlocked$ | async) || isDisabled || isBusinessRuleBlocked"
    [ngModel]="value"
    (ngModelChange)="onSwitchChange($event)"
  ></nz-switch>

  <nz-spin [nzSpinning]="loading$ | async" [nzSize]="'small'">
    <ng-container *ngIf="greenCornerData$ | async as data">
      <span class="switch-text">
        {{ 'LOT_BIDDING_MODAL.GREEN_CORNER' | translate : { price: (data.price | formatCurrency) } }}
        <ng-container *ngIf="isMoto">
        <br />
          {{ 'LOT_BIDDING_MODAL.GREEN_CORNER_MOTO_WARNING' | translate: { limit: (data.motoBidLimit | formatCurrency) } }}
      </ng-container>
    </span>
    </ng-container>
  </nz-spin>
</div>

<nz-alert
  class="switch-alert"
  nzType="warning"
  *ngIf="isBoundaryBlocked$ | async"
  [nzMessage]="'LOT_BIDDING_MODAL.GREEN_CORNER_WARNING' | translate"
></nz-alert>
